// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3RSi6","author":"Table_author__29OZK","authorImage":"Table_authorImage__36ugY","unreadRow":"Table_unreadRow__3ku7n"};